import { PromotionSeoConfig } from 'libs/shared-lib/interfaces/seo/seo-partner-web';

export const PROMOTIONS_SEO_DE: PromotionSeoConfig = {
    list: {
        title: 'Aktionen',
        description: '',
        image: '',
        twitter: {
            card: 'summary',
            title: 'Aktionen',
            description: '',
        },
        og: {
            title: 'Aktionen',
            description: '',
        },
        robots: {
            noIndex: false,
            noFollow: false,
        },
    },
    detail: {
        title: 'promotion Detail',
        description: '',
        image: '',
        twitter: {
            card: 'summary',
            title: 'promotion-detail',
            description: '',
        },
        og: {
            title: 'promotion Detail',
            description: '',
        },
        robots: {
            noIndex: false,
            noFollow: false,
        },
    },
};
